import React from 'react'
import Exporter from 'services/csv/exporter'
import CatalogItemBaseList, {
  CatalogItemBaseListProps,
} from 'ui-shared/WrappedInputs/CatalogItemBaseList'

const DrinkSectionList: React.FC<CatalogItemBaseListProps> = (props) => (
  <CatalogItemBaseList {...props} exporter={Exporter()} />
)

export default DrinkSectionList
